export default __webpack_public_path__ + "static/testimonial-isabella-476d4f26cd858c1ea24bdcb9308800ce.png";